export const getters = {
  notifications: (state) => state.notifications,
  persistentNotifications: (state) => state.persistentNotifications
};
